import { render, staticRenderFns } from "./QueryMatches.vue?vue&type=template&id=e79cec7a&"
import script from "./QueryMatches.vue?vue&type=script&lang=js&"
export * from "./QueryMatches.vue?vue&type=script&lang=js&"
import style0 from "./QueryMatches.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports